import React from "react";
import {
  Box, Divider, FormControl, FormControlLabel,
  FormLabel, Grid, InputAdornment, Radio, RadioGroup,
  TextField, Typography,
} from "@mui/material";

export default function BaselineData({ form, onChange }) {
  return (
    <Box>
      <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
        Datos Basales
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={2.5}>
        {/* Fuerza de prensión — brazo afectado */}
        <Grid item xs={12} sm={4}>
          <TextField
            label="Fuerza de prensión — brazo afectado"
            name="grip_strength_affected_arm"
            type="number"
            value={form.grip_strength_affected_arm}
            onChange={onChange}
            fullWidth
            inputProps={{ min: 0, step: 0.1 }}
            InputProps={{ endAdornment: <InputAdornment position="end">kg</InputAdornment> }}
          />
        </Grid>

        {/* Fuerza de prensión — brazo no afectado */}
        <Grid item xs={12} sm={4}>
          <TextField
            label="Fuerza de prensión — brazo no afectado"
            name="grip_strength_unaffected_arm"
            type="number"
            value={form.grip_strength_unaffected_arm}
            onChange={onChange}
            fullWidth
            inputProps={{ min: 0, step: 0.1 }}
            InputProps={{ endAdornment: <InputAdornment position="end">kg</InputAdornment> }}
          />
        </Grid>

        {/* Medida con robot */}
        <Grid item xs={12} sm={4}>
          <FormControl>
            <FormLabel>¿Fuerza de prensión medida con robot?</FormLabel>
            <RadioGroup
              row
              name="grip_robot_measured"
              value={form.grip_robot_measured === null ? "" : form.grip_robot_measured ? "1" : "0"}
              onChange={(e) =>
                onChange({ target: { name: "grip_robot_measured", value: e.target.value === "1" } })
              }
            >
              <FormControlLabel value="1" control={<Radio />} label="Sí" />
              <FormControlLabel value="0" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* ARAT */}
        <Grid item xs={12} sm={4}>
          <TextField
            label="ARAT (0–57)"
            name="arat"
            type="number"
            value={form.arat}
            onChange={onChange}
            fullWidth
            inputProps={{ min: 0, max: 57 }}
            helperText="Action Research Arm Test"
          />
        </Grid>

        {/* Fugl-Meyer UE */}
        <Grid item xs={12} sm={4}>
          <TextField
            label="Fugl-Meyer UE (0–66)"
            name="fugl_meyer_ue"
            type="number"
            value={form.fugl_meyer_ue}
            onChange={onChange}
            fullWidth
            inputProps={{ min: 0, max: 66 }}
            helperText="Upper Extremity Motor Assessment"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
